import * as React from 'react';
import { createElement } from 'react';
import './index.scss';
const Tab = ({ selectedBGColor, selectedFontColor, size, onClickHandle, unreadCount, ...otherProps }) => {
    const tabList = [
        { key: [0, 1], label: '全部' },
        { key: [1], label: '已读' },
        { key: [0], label: '未读' },
    ];
    const [tab, setTab] = React.useState([0, 1]);
    const handleClick = (key) => {
        console.log(key);
        setTab(key);
        onClickHandle && onClickHandle(key);
    };
    return (createElement("div", { className: "tab-message" }, tabList.map((item) => (createElement("span", { className: `tabs__container
         ${tab.toString() === item.key.toString() ? 'tabs__container--selected' : ''}
         ${size == 'large' ? 'tabs__container--large' : 'tabs__container--small'}`, ...otherProps, onClick: () => handleClick(item.key), style: {
            backgroundColor: tab.toString() === item.key.toString() ? selectedBGColor : '',
            color: tab.toString() === item.key.toString() ? selectedFontColor : '',
        } },
        item.label,
        item.key.toString() === '0' && unreadCount > 0 && (createElement("span", { className: "badge" }, unreadCount)))))));
};
export default Tab;
